/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Not_TitleInputs */

const fr_help_not_title = /** @type {(inputs: Help_Not_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce n'est pas`)
};

const en_help_not_title = /** @type {(inputs: Help_Not_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is not`)
};

/**
* | output |
* | --- |
* | "It is not" |
*
* @param {Help_Not_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_not_title = /** @type {((inputs?: Help_Not_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Not_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_not_title(inputs)
	return en_help_not_title(inputs)
});